import { resourceExplorerPathSelector } from "./resourceExplorerPathSelector";
import { RootState } from "../../../../store";

export const resourceExplorerPathLastItemFiltersSelector = (
  state: RootState,
) => {
  const path = resourceExplorerPathSelector(state);

  return path?.at(-1)?.includedFilters;
};
